(function () {'use strict';}());

angular.module('app')
  .controller('AudioController', function ($scope,$timeout,$rootScope,$document,$q,AppService) {
  	var trace = angular.trace;
  	var player = null;
    var background = null;

  	$scope.currentAudio = null;
    $scope.currentBackgroundAudio = null;
    $scope.currentAudioOGG = null;
    $scope.currentBackgroundAudioOGG = null;
    $scope.deferred = null;
    $scope.loop = null;
    $rootScope.audioOn = true;

    $rootScope.requestAudio = function(filename,loop){
      player = $document.find("#global-audio").get(0);
      $scope.deferred = $q.defer();
      if(loop) $(player).attr("loop",loop);
      else $(player).attr("loop",null);
      $scope.currentAudio = 'audio/' + filename + '.mp3';
      $scope.currentAudioOGG = 'audio/' + filename + '.ogg';
      $timeout(function(){
        player.load();
      },0);
      return $scope.deferred.promise;
    }; 
    $rootScope.stopAudio = function(){
      try {
        player.pause();
      }
      catch(e){}
    };
    
    $rootScope.requestBackgroundAudio = function(filename){
      background = $document.find("#background-audio").get(0);
      $scope.currentBackgroundAudio = 'audio/' + filename + '.mp3';
      $scope.currentBackgroundAudioOGG = 'audio/' + filename + '.ogg';
      $timeout(function(){
        background.oncanplay = backgroundPlay;
        background.oncanplaythrough = backgroundPlay;
        background.volume = $rootScope.audioOn ?  1 : 0;
        background.load();
        background.play();
      },0);
    };
    $rootScope.stopBackgroundAudio = function(){
      try {
        background.pause();
      }
      catch(e){}
    };
    function onVolumeChange(value){
      if(player) player.volume = value ? 1  : 0;
      if(background) background.volume = value ? 1  : 0;
    }
  	function onAudioRequest(type,filename){
      $scope.deferred = null;
      player = $document.find("#global-audio").get(0);
      $(player).attr("loop",null);
      player.oncanplay = play;
      player.oncanplaythrough = play;
      player.onended = complete;
      player.volume = $rootScope.audioOn ?  1 : 0;

  		$scope.currentAudio = 'audio/' + filename + '.mp3';
      $scope.currentAudioOGG = 'audio/' + filename + '.ogg';
  		$timeout(function(){
        player.load();
        player.play();
        //
  		},100);
  	}
  	function intialize(){
      background = $document.find("#background-audio").get(0);
  		player = $document.find("#global-audio").get(0);
  		
      player.oncanplay = play;
      player.oncanplaythrough = play;
      player.onended = complete;
      player.volume = $rootScope.audioOn ?  1 : 0;

      background.oncanplay = backgroundPlay;
      background.oncanplaythrough = backgroundPlay;
      background.volume = $rootScope.audioOn ?  1 : 0;

  		$rootScope.$on("audio",onAudioRequest);
      $rootScope.$on("audioLoad",onAudioLoad);
      $rootScope.$watch("audioOn",onVolumeChange);

  	}
  	function play(){
      trace("attempting to play: " + $scope.currentAudio);
  		player.play();
  	}
    function backgroundPlay(){
      background.play();
    }
    function complete(){
      if($scope.deferred) $scope.deferred.resolve();
    }

    function onAudioLoad(){
      var ext = extension();
      var clips = AppService.audio.concat();
      for(var i = 0, count = clips.length; i < count; i++){
        var clip = clips[i];
        clips[i] = "audio/"+clip + ext;
      }
      preload.bind(clips)();
    }

    function preload(){
      if(!this.length) return trace("complete");
      var clip = this.shift();
      var audio = new Audio();
      audio.addEventListener("canplaythrough",preload.bind(this));
      audio.src = clip;
      audio.load();
    }

    function extension(){
      var ext = ".mp3";
      var agent = navigator.userAgent.toLowerCase();
      if(agent.indexOf('firefox') != -1 || agent.indexOf('opera') != -1) {
          ext = ".ogg";
      }
      return ext;
    }

  	intialize();
  });
